module.exports = __webpack_public_path__ + "static/media/attack-of-the-clones.2afcdd98.png";